<template>
  <div style="margin: 25px">
    <!--   <b-table responsive="sm" hover :items="satisListesi" :fields="fields" />
    <ag-grid-vue
      style="width: 100%; height: 350px; margin-top: 25px"
      class="ag-theme-alpine"
      :defaultColDef="defaultColDef"
      :columnDefs="columnDefs"
      :rowData="satisListesi"
      :localeText="localeText"
      @grid-ready="onGridReady"
      @first-data-rendered="onFirstDataRendered"
      :autoGroupColumnDef="autoGroupColumnDef"
    >
    </ag-grid-vue>-->

    <vue-good-table
      :columns="satisListesicolumns"
      :rows="gruplananACT"
      :rtl="dir"
      max-height="350px"
      :fixed-header="true"
      :group-options="{
        enabled: true,
      }"
    >
      <template slot="table-row" slot-scope="props">
        <div v-if="props.column.field === 'TRANSDATE'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.TRANSDATE }}</span>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { BTable } from "bootstrap-vue";
//import vuetify from "@/plugins/vuetify";
export default {
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        rowGroup: true,
        sortable: true,
        filter: true,
      },
      {
        headerName: "Belge No",
        field: "ROOTRECEIPTNO",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Tarih",
        field: "TRANSDATE",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Adet",
        field: "QENTRY",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Fiyat",
        field: "PRICE",
        sortable: true,
        filter: true,
      },
    ];
  },
  data() {
    return {
      fields: [
        {
          label: "Cari Adı",
          key: "ACTNAME",
        },
        {
          label: "Belge No",
          key: "ROOTRECEIPTNO",
        },
        {
          label: "Tarih",
          key: "TRANSDATE",
        },
        {
          label: "Adet",
          key: "QENTRY",
        },
        {
          label: "Fiyat",
          key: "PRICE",
        },
      ],

      autoGroupColumnDef: null,
      localeText: null,

      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: [],
      dir: false,

      satisListesi: [],

      satisListesicolumns: [
        {
          label: "Cari Adı",
          field: "ACTNAME",
        },
        {
          label: "Belge No",
          field: "ROOTRECEIPTNO",
        },
        {
          label: "Tarih",
          field: "TRANSDATE",
        },
        {
          label: "Adet",
          field: "QENTRY",
        },
        {
          label: "Fiyat",
          field: "PRICE",
        },
      ],
      gruplananActname: [],
      gruplananACT: [],
    };
  },
  methods: {
    groupByACTNAME() {},
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    satislar() {
      var vm = this;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        STOCKID: Store.state.account.stokId,
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_StockEktsre_Satislar(args, function (err, result) {
          if (result.INT_Ls_StockEktsre_SatislarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_StockEktsre_SatislarResult);
          vm.satisListesi = vm.veriler;

          var actnameGrup = _.groupBy(vm.veriler, (veri) =>
            JSON.stringify({ ACTNAME: veri.ACTNAME })
          );
          const gruplanmisAylarListesi = Object.keys(actnameGrup);
          gruplanmisAylarListesi.forEach((key, i) => {
            var pazaryeriyillar = actnameGrup[key];
            vm.gruplananActname.push(pazaryeriyillar);
          });

          for (var index = 0; index < vm.gruplananActname.length; index++) {
            var altGrup = [];
            for (var i = 0; i < vm.gruplananActname[index].length; i++) {
              altGrup.push({
                ACTNAME: vm.gruplananActname[index][i].ACTNAME,
                ROOTRECEIPTNO: vm.gruplananActname[index][i].ROOTRECEIPTNO,
                TRANSDATE: vm.gruplananActname[index][i].TRANSDATE,
                QENTRY: vm.gruplananActname[index][i].QENTRY,
                PRICE: vm.gruplananActname[index][i].PRICE,
              });
            }
            vm.gruplananACT.push({
              mode: "span",
              label: vm.gruplananActname[index][0].ACTNAME,
              html: false,
              children: altGrup,
            });
          }
        });
      });
    },
  },
  components: { AgGridVue, BTable },
  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.satislar();
    this.autoGroupColumnDef = {
      minWidth: 200,
    };
  },
};
</script>
<style lang="scss">
.ag-hidden {
  display: none !important;
}
[dir] .vgt-table.bordered th.vgt-row-header {
  text-align: center;
}
</style>